/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZugInputs */

const de__field_zug = /** @type {(inputs: _Field_ZugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zug`)
};

/**

* @param {_Field_ZugInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_zug = /** @type {((inputs?: _Field_ZugInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZugInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zug(inputs)
});